import { render, staticRenderFns } from "./qlik.vue?vue&type=template&id=4fcc2a60&"
import script from "./qlik.vue?vue&type=script&lang=js&"
export * from "./qlik.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports